import { PacketTypeOption } from '../../../@types/FlightBriefing.type';

/** Flight briefing documents available from `getflightbriefingdocument/{packetType}`. */
export const PACKET_TYPES: PacketTypeOption[] = [
  { value: 'pdf-ofp', title: 'Operational Flight Plan', format: 'PDF' },
  { value: 'pdf-combined', title: 'Combined Document', format: 'PDF' },
  { value: 'pdf-windcharts', title: 'Wind Charts', format: 'PDF' },
  { value: 'pdf-weather-briefing', title: 'Weather Briefing', format: 'PDF' },
  { value: 'pdf-notam-briefing', title: 'NOTAM Briefing', format: 'PDF' },
  {
    value: 'pdf-takeoff-landing-performance',
    title: 'Takeoff and Landing Performance',
    format: 'PDF',
  },
  {
    value: 'xml-arinc633-6-flightplan',
    title: 'ARINC 633-6 Flight Plan',
    format: 'XML',
  },
  {
    value: 'xml-arinc633-6-flightplan-atc-icao',
    title: 'ARINC 633-6 Flight Plan ATC ICAO',
    format: 'XML',
  },
  {
    value: 'xml-fk-takeoff-landing-performance',
    title: 'Takeoff and Landing Performance',
    format: 'XML',
  },
];

/** Title plus format, so packet types with the same title (PDF and XML) stay distinguishable. */
export const getPacketDisplayName = (packet: PacketTypeOption): string =>
  `${packet.title} (${packet.format})`;
